
import { useEffect, useState } from "react";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup"
import axios from "../../../config/axios";
import baseURL from "../../../config/api";
import useAuth from "../../../hook/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import DeletePopup from "../../../components/DeletePopup";
import useDelete from "../../../hook/useDelete";
import { delete_CourseCategory } from "../../../services/Course";
import useConfirm from "../../../hook/useConfirm";
import { ConfirmPopup } from "../../../components/ConfirmPopup";

export const EditCourseCategory = () => {
    const { auth }: any = useAuth();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const navigate = useNavigate();
    const idNumber = useLocation();
    const [name, setName] = useState<string>("");
    const [categoryData, setCategoryData] = useState<any>(null);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    useEffect(() => {
        setPleaseWaitPopup(true);
        axios
            .get(`${baseURL}courseCategories/${idNumber?.state}`)
            .then((response) => {
                setCategoryData(response?.data);
                setName(response?.data?.name);
                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
            });
      
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await axios
            .put(
                `${baseURL}courseCategories?userId=${auth?.id}`,
                JSON.stringify({
                    ...categoryData,
                    name,
                    updatedAt: new Date().toLocaleString(),
                    updatedBy: auth?.givenname
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    const handleDelete = () => {
        if (idNumber?.state) {
            setDeletePopup(true);
            setDeleteData({
                id: idNumber?.state,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this course category?`,
                isDelete: (callback: any) => {
                    delete_CourseCategory(idNumber?.state, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            callback();
                            navigate(-1);
                        })
                        .catch(error => {
                            console.log(error);
                            callback();

                            setConfirmData({
                                title: 'Warning',
                                summary: error.response.data,
                                confirmBtn: 'Ok',
                                isConfirm: (callback: any) => {
                                    callback();
                                }
                            });

                            setConfirmPopup(true);
                        });
                }
            });
        }
    }

    return (
        <>
            <div className="w-full p-4 bg-white rounded-md">
                <h2 className={`text-lg font-semibold`}>Edit Category</h2>

                <div className="mt-2 p-2">
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="w-full">

                            {/* Responsive Form Grid */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                {/* First Column */}
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-xs font-medium text-[#667085]">Name</label>
                                        <input
                                            type="text"
                                            className="w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent"
                                            value={name}
                                            placeholder="Name"
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>

                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                <button
                                    type="submit"
                                    className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate(-1)}
                                    className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={() => handleDelete()}
                                    className="w-full sm:w-auto px-4 py-2 rounded bg-[#D92D20] text-white cursor-pointer"
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />

            <DeletePopup />
            <ConfirmPopup />
        </>
    )
}